<template>
  <div
    class="main-card d-flex p-a-16 align-items-center align-self-stretch justify-content-between"
    @click="handleButtonClick"
  >
    <div
      class="its-texts d-flex flex-column align-items-start"
      style="gap: 8px"
    >
      <p class="f-Overpass f-16 f-w-600 my-0">{{ namaCust }}</p>
      <div class="d-flex mt-1 align-items-center" style="gap: 4px">
        <p class="f-Overpass f-12 f-w-400 my-0 f-c-grey">
          Terakhir digunakan pada <br />
          {{ this.$moment(updated_at).format("L") }}
        </p>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-between align-items-center">
      <p class="f-Overpass f-16 f-w-400 my-0 f-c-blue">
        {{ displaySaldo(saldo) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "cardEpay",
  props: {
    namaCust: String,
    updated_at: String,
    saldo: Number,
    idcustomer: String,
    idoutlet: String,
    namaoutlet: String,
  },
  data() {
		return {
			idNota: null,
		}  
  },
  computed: {
    ...mapState("scan", {
      dataCustomer: "dataCustomer",
      dataPesanan: "dataPesanan",
    }),
  },
  methods: {
    formatDate(){
      const now = new Date();
      const year = String(now.getFullYear()).slice(-2); // Dua digit terakhir dari tahun
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan mulai dari 0, jadi tambah 1
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
    },

    handleButtonClick() {
      if (this.saldo >= this.dataPesanan.grandtotal) {
        let data = {
          idcustomer: this.idcustomer,
          id: this.idNota,
          idoutlet: this.idoutlet,
          namaoutlet: this.namaoutlet,
          namacustomer: this.namaCust,
          saldocustomer: this.saldo,
        };
        this.$store.commit("scan/dataIdCustomer", data);
        // console.log(this.dataCustomer);
        this.$router.push({ name: "pembayaran" });
      }
      if (this.saldo < 1 || this.saldo < this.dataPesanan.grandtotal) {
        this.$toast.error("saldo epay tidak cukup", { position: "top" });
      }
    },

    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
    },
  },
  mounted() {
		this.idNota = "SLF" + this.formatDate()	
  },
};
</script>

<style scoped>
.main-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}
</style>
